import { AuthenticationService } from "@/services/authentication/AuthenticationService";
// eslint-disable-next-line import/no-cycle
import store from "@/store";
import {
  UPDATE_TOKEN,
  UPDATE_IS_AUTHORIZED
} from "@/constants/mutations";
import {
  UPDATE_TOKEN_TIMER
} from "@/constants/actions";

export class AuthenticationProvider {
  constructor (authData, token) {
    this.authData = authData;

    if (token) {
      this.token = token;
      store.dispatch(`authentication/${ UPDATE_TOKEN }`, token);
      store.dispatch(`authentication/${ UPDATE_TOKEN_TIMER }`);
    }

    store.commit(`authentication/${ UPDATE_IS_AUTHORIZED }`, true);
  }

  static async signInByPassword (login, password) {
    await AuthenticationService.signInByPassword(login, password);
    const authData = {};
    const token = {
      refresh: "b29c702eb32817b6d0cd6e05ac903f8a",
      // eslint-disable-next-line max-len
      access: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2NzIxMjY0NTksImV4cCI6MTY4MzI0MDA1OSwibG9naW4iOiJwdWJsaXNoZXJAZ21haWwuY29tIiwicGVybWlzc2lvbnMiOltdfQ.E-J5E4eNsD37yDfMbTTs6ctqt_Xa6odkl6fIIKnukommnmQO4T6Jyio42tEeIjHZcwR8LiP16ZCdoybCGyuFp2im5Y8GzQ2Oh0zOkeKXCXWw67lgtbBDl9oMlGuknnkKQK4RZrUDthHJpG9wOqR_cvfIIbV1ekMssXjAW8b7ER4IpwkJZlvVoyVKTR9JSMxAUpLrfKfbsi3LU8JmM6iFcr2Y3oR8sWgbqp8xlV2XA0pQ3R7_h-PGwE-05FGh0prSa4VrptE24DsKueyo_jmhz0rWZZvjsvgki-yQLptLNs71U03FETn-M-joFtzgEHakkZtfvD_3VfYOkNN-hR0NFA"
    };

    return new AuthenticationProvider(authData, token);
  }

  static async signInByToken () {
    await AuthenticationService.whoAmI();
    const authData = {};

    return new AuthenticationProvider(authData);
  }

  static async getFreshTokens (currentRefreshToken) {
    await AuthenticationService.refreshToken(currentRefreshToken);

    return {
      refresh: null,
      access: null
    };
  }
}
